import Comments from 'components/Comments';
import type { KeyValueCallback } from 'types/utils.type';
import {
  EPaddingRuleType,
  type TDirectPaddingRule,
  type TPaddingRule,
  type TTravelTimePaddingRule,
} from '@timeedit/types';
import DirectPadding from './DirectPadding';
import ObjectCriteriaSection from './ObjectCriteriaSection';
import PaddingRuleInfo from './PaddingRuleInfo';
import TravelTimePadding from './TravelTimePadding';
import './PaddingRule.scss';

export interface PaddingRuleProps {
  paddingRule?: TPaddingRule;
  onChange: KeyValueCallback<TPaddingRule>;
  isExpand: boolean;
}

const PaddingRule = (props: PaddingRuleProps) => {
  const { paddingRule, onChange, isExpand } = props;
  if (!paddingRule) return null;
  return (
    <div className="padding-rule">
      <PaddingRuleInfo paddingRule={paddingRule} onChange={onChange} />
      {paddingRule.paddingType === EPaddingRuleType.DIRECT ? (
        <DirectPadding
          rule={paddingRule.rule as TDirectPaddingRule}
          onChange={(rule) => onChange('rule', rule)}
        />
      ) : (
        <TravelTimePadding
          rule={paddingRule.rule as TTravelTimePaddingRule}
          onChange={(rule) => onChange('rule', rule)}
        />
      )}
      <ObjectCriteriaSection
        paddingRule={paddingRule}
        onChange={onChange}
        isExpand={isExpand}
      />
      <Comments
        value={paddingRule.description}
        onChange={(val) => onChange('description', val)}
        data-testid="comment"
      />
    </div>
  );
};

export default PaddingRule;
